module.exports = __webpack_public_path__ + "static/media/time-stamp.93e93d51.png";